/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/212-bookmarks': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M4 2v14l5-5 5 5V2zm8-2H2v14l1-1V1h9z"/>'
  }
})
